/**
 * Grid Empty State Component
 * Displays when no sessions are found
 */

import { FileSearch, RefreshCw } from 'lucide-react';
import { Button } from '@/core/components/ui/button';

interface GridEmptyStateProps {
  title?: string;
  description?: string;
  onRefresh?: () => void;
}

export const GridEmptyState = ({
  title = 'No Sessions Found',
  description = 'No charging sessions found for the selected date range.',
  onRefresh,
}: GridEmptyStateProps) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="rounded-full bg-gray-100 p-4 mb-4">
        <FileSearch className="h-8 w-8 text-gray-400" />
      </div>
      <h3 className="text-lg font-medium text-gray-900 mb-2">{title}</h3>
      <p className="text-sm text-gray-500 text-center max-w-md mb-6">
        {description}
      </p>
      {onRefresh && (
        <Button
          onClick={onRefresh}
          variant="outline"
          className="flex items-center gap-2"
        >
          <RefreshCw className="h-4 w-4" />
          Refresh
        </Button>
      )}
    </div>
  );
};
